import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiCard, { CardProps } from '@material-ui/core/Card';

const Card: React.FC<CardProps> = withStyles({
  root: {
    height: '100%',
    backgroundColor: 'transparent',
    borderRadius: 4,
  },
})(({ classes, elevation = 1, ...props }) => (
  <MuiCard elevation={elevation} {...props} classes={classes} />
));

export default Card;
